import React from 'react';
import { aiService } from '../../../services/aiService';
import { useAiRequest } from '../moments/useAiRequest';
import { AiBox, AiSection } from '../moments/AiBox';
import { AiItems, itemsToText } from '../moments/AiItems';
import { Spinner } from '../../ui/Spinner';
import { Alert } from '../../ui/Alert';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../../common/SafeIcon';

const buildText = (r) =>
  `${r.summary || ''}\n\n` +
  itemsToText('Themes', r.themes) +
  itemsToText('Shared experiences', r.shared_experiences) +
  itemsToText('Commitments', r.commitments) +
  itemsToText('Worth remembering', r.reminders) +
  itemsToText('Ways to stay in touch', r.suggestions);

export const ConnectionInsights = ({ contactId, name, moments, onOpenMoment }) => {
  const ai = useAiRequest();
  const withText = moments.filter((m) => (m.body || '').trim()).length;
  const r = ai.data?.result;

  return (
    <div className="space-y-3">
      <div className="flex flex-wrap items-center gap-3">
        <button
          type="button"
          disabled={ai.loading || withText === 0}
          onClick={() => ai.run(() => aiService.relationshipInsights(contactId))}
          className="flex items-center gap-1.5 rounded-full border border-violet-200 bg-violet-50 px-3 py-1.5 text-xs font-semibold text-violet-700 hover:bg-violet-100 disabled:opacity-50"
        >
          <SafeIcon icon={FiIcons.FiStar} /> Explore relationship insights
        </button>
        {withText === 0 && (
          <p className="text-xs text-slate-500">Insights need at least one Moment with written notes.</p>
        )}
      </div>
      {ai.loading && <p className="flex items-center gap-2 text-xs text-slate-500"><Spinner size="sm" /> Reading your Moments with {name}…</p>}
      {ai.error && <Alert variant="error" title="AI is unavailable" message={ai.error} />}
      {ai.data && (
        <AiBox title={`Insights on ${name}`} meta={ai.data.meta} copyText={ai.data.insufficient ? '' : buildText(r)} onDismiss={ai.reset}>
          {ai.data.insufficient ? <p>{ai.data.message}</p> : (
            <>
              {r.summary && <AiSection label="Relationship history"><p>{r.summary}</p></AiSection>}
              <AiItems label="Recurring themes" items={r.themes} moments={moments} onOpen={onOpenMoment} />
              <AiItems label="Shared experiences" items={r.shared_experiences} moments={moments} onOpen={onOpenMoment} />
              <AiItems label="Commitments you recorded" items={r.commitments} moments={moments} onOpen={onOpenMoment} />
              <AiItems label="Worth remembering" items={r.reminders} moments={moments} onOpen={onOpenMoment} />
              <AiItems label="Ways to stay in touch" items={r.suggestions} moments={moments} onOpen={onOpenMoment} />
              <p className="text-[11px] text-violet-700/70">
                Based on {ai.data.meta?.moments_considered} of your Moments. Tap a date to open the original.
              </p>
            </>
          )}
        </AiBox>
      )}
    </div>
  );
};